/** @module SiteAdmin/Locale/DateExampleRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"./util"
], function(declare,Renderer,util) {

	return declare(Renderer, {

		/**
		 * Format the date against the particular pattern
		 */
		toValue: function(ctx, h) {
			var locale = ctx.getNode();
			var pattern =  util.getLocaleSettings(ctx).DatePattern;

			var result = util.getDateTimeFormatBasedOnLocale(locale, "date", pattern);
			return result;
		}
	});
});